// S=0.5, V=0.99
const COLORS = [
  '#98fdc1',
  '#fda398',
  '#98a9fd',
  '#c7fd98',
  '#fd98e5',
  '#98fdf8',
  '#fdda98',
  '#bd98fd',
  '#98fd9f',
  '#fd98ae',
  '#98cbfd',
  '#e9fd98',
  '#f398fd',
  '#98fdd6',
  '#fdb898',
  '#9b98fd',
  '#b2fd98',
  '#fd98d0',
  '#98edfd',
  '#fdef98',
  '#d298fd',
  '#98fdb4',
  '#fd9899',
  '#98b6fd',
  '#d4fd98',
  '#fd98f1',
];

export function getCursorColor(cursor) {
  return COLORS[cursor.cursorId % COLORS.length];
}
